import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Navbar from "../components/Navbar";
import Carousel from "../components/Carousel";
import Services from "../components/Services";
import Footer from "../components/Footer";
import { profileUser } from "../api/service";
import Axios from "axios";
import Chatbot from "../components/Chatbot";
import NearbyCarousel from "../components/NearbyCarousel";
import OnboardModal from "../components/Modal";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  FaRegThumbsUp,
  FaThumbsUp,
  FaRegThumbsDown,
  FaThumbsDown,
} from "react-icons/fa";
// import toast, { Toaster } from "react-hot-toast";

// function notifysuccess() {
//   toast.success("Liked");
// }
// function notifyerror() {
//   toast.error("Disiked");
// }

const Home = () => {
  let token = localStorage.getItem("token");
  const [name, setName] = useState("");
  const [id, setId] = useState("");
  const[tokens,setTokens] = useState(0);
  const navigate = useNavigate();
  const [posts, setPosts] = useState();
  const [lati, setLati] = useState();
  const [long, setLong] = useState();
  const [distances, setDistances] = useState([]);
  const [distance, setDistance] = useState(0);
  let api_key = process.env.REACT_APP_REVGEO_API;
  const profileInit = () => {
    profileUser(token).then((req, res) => {
      console.log(req.data);
      if (req.data.status !== "failed") {
        setName(req.data.userValidation.name);
        setId(req.data.userValidation._id);
        setTokens(req.data.userValidation.token);
        console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaa')
        console.log(req.data.userValidation)
        console.log(req.data);
      } else {
        navigate("/");
      }
    });
  };

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        console.log("Latitude is :", position.coords.latitude);
        console.log("Longitude is :", position.coords.longitude);
        setLati(position.coords.latitude);
        setLong(position.coords.longitude);
      });
    }
    else {
      console.log('nahi hori location');
    }
  };

  const [nearbyPosts, setNearbyPosts] = useState([])

  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const earthRadius = 6371; // Radius of the Earth in kilometers
    const dLat = toRadians(lat2 - lat1);
    const dLon = toRadians(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const distance = earthRadius * c;
    return distance.toFixed(2); // Return distance rounded to 2 decimal places
  };

  const toRadians = (angle) => {
    return angle * (Math.PI / 180);
  };
  const calculateRadius = () => {
    if (posts && lati && long) {
      const updatedPosts = posts.map(post => ({
        ...post,
        distance: calculateDistance(post.lat, post.lng, lati, long),
      }));
  
      const nearbyPosts = updatedPosts.filter(post => post.distance < 2);
      setPosts(updatedPosts);
      setNearbyPosts(nearbyPosts);
    }
  };
  
  
  
  useEffect(() => {
    console.log(distances);
  }, [distances])

  useEffect(() => {
    console.log(posts);
  }, [posts])

  useEffect(()=>{

  },[tokens])

  useEffect(() => {
    console.log("useEffect for tokens")
    console.log(id)
    Axios.get(process.env.REACT_APP_API_BASE_URL + "/api/users/" + id, {
      headers: {
        authorization: token,
      },
    })
      .then((res) => {
        console.log("fetching user")
        console.log(res.data);
        setTokens(res.data.token);
        if(res.data.token !== res.data.backuptoken){
          if(res.data.token >= res.data.backuptoken){
            console.log(res.data.backuptoken)
            toast.info(`You gained ${res.data.token-res.data.backuptoken} tokens`);
            console.log(`You gained ${res.data.token-res.data.backuptoken} tokens`)
          }else {
            toast.info(`${res.data.backuptoken-res.data.token} tokens were deducted`);
            console.log(`${res.data.backuptoken-res.data.token} tokens were deducted`)
          }
          Axios.put(process.env.REACT_APP_API_BASE_URL + "/api/users/updateTokens/" +id).then((res) => {
            console.log(res.data);
          }).catch((err) => console.log(err));
        }
      })
      .catch((err) => console.log(err));
  }, [id]);

  useEffect(() => {
    Axios.get(process.env.REACT_APP_API_BASE_URL + "/api/posts/", {
      headers: {
        authorization: token,
      },
    })
      .then((res) => {
        console.log(res.data);
        setPosts(res.data);
      })
      .catch((err) => console.log(err));
  }, []);
  
  useEffect(() => {
    profileInit();
  }, []);

  useEffect(() => {
    calculateRadius();
    getLocation();
  }, [lati, long]);

  useEffect(() => {
    // window.location.reload();
    console.log("middle");
  }, [distance])

  useEffect(() => {
    console.log("Nearby Posts", nearbyPosts);
  }, [nearbyPosts]);


  const handleLike = async (postId) => {
    try {
      const response = await Axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/posts/${postId}/like`,
        null,
        {
          headers: {
            authorization: token,
          },
        }
      );

      const updatedPosts = posts.map((post) => {
        if (post._id === postId) {
          return { ...post, likes: response.data.likes };
        }
        return post;
      });

      setPosts(updatedPosts);
    } catch (error) {
      console.error(error);
    }
  };
  const handleDislike = async (postId) => {
    try {
      const response = await Axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/posts/${postId}/dislike`,
        null,
        {
          headers: {
            authorization: token,
          },
        }
      );

      const updatedPosts = posts.map((post) => {
        if (post._id === postId) {
          return { ...post, dislikes: response.data.dislikes };
        }
        return post;
      });

      setPosts(updatedPosts);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>

      <Navbar />
      <OnboardModal />
      <div class="dark:bg-[#161b22] bg-[#f5f5f5] ">
        <div class="p-4 flex flex-row items-start left-2 justify-between">
          <div class="text-2xl font-bold text-[#383838]"> Hello, {name}</div>
          <div class=" font-bold"> 
          <span class="inline-flex items-center px-2 font-bold text-md py-1 bg-gray-200 hover:bg-gray-300 rounded-lg  text-gray-600">
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24"><path fill="#145ca9" d="M11 18h1l4-6h-3V8h-1l-4 6h3zm1 4q-3.425 0-5.712-2.35T4 13.8q0-2.5 1.988-5.437T12 2q4.025 3.425 6.013 6.363T20 13.8q0 3.5-2.287 5.85T12 22m0-2q2.6 0 4.3-1.763T18 13.8q0-1.825-1.513-4.125T12 4.65Q9.025 7.375 7.513 9.675T6 13.8q0 2.675 1.7 4.438T12 20m0-8"/></svg> {tokens}
            </span>
         
          </div>
        </div>
        <NearbyCarousel nearbyPosts={nearbyPosts} />
        <Footer />
      </div>
    </>
  );
};

export default Home;
